import { render, staticRenderFns } from "./StudentAttendence.vue?vue&type=template&id=74a19030"
import script from "./StudentAttendence.vue?vue&type=script&lang=js"
export * from "./StudentAttendence.vue?vue&type=script&lang=js"
import style0 from "./StudentAttendence.vue?vue&type=style&index=0&id=74a19030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports